import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  useLocation, useNavigate, Outlet, useSearchParams,
} from 'react-router-dom';
import { BreadcrumbComponent } from '../Partials/Breadcrumb';
import xCal from '../../lib/calc';
import EventMore from '../Event/EventMore';

const Gallery = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);

  const [searchParams, setSearchParams] = useSearchParams();

  // Календарь
  const calendar = () => {
    const nameId = document.getElementById('date8');

    if (nameId) {
      xCal('date8', {
        id: 'cssworldru8', // Задать уникальный ID
        'class': 'xcalend', // CSS класс оформления внешнего вида
        hide: 0, // Не скрывать календарь
        x: 0, // Отключить кнопку закрытия календаря
        autoOff: 0, // Отключить автоматическое скрытие
        to: 'date8', // Разместить календарь внутри элемента с id=date8
        fn: '', // Вызвать функцию с указанным названием, в нее будет передан результат выбора
      });
    }
  };

  // Handle click value on calendar and pass it to URL;
  const handleSelectSearchByDate = () => {
    if (xCal.value !== null) {
      searchParams.set('date', xCal.value);
      searchParams.delete('page');
    } else {
      searchParams.delete('date');
    }
    setSearchParams(searchParams);
  };

  const handleKeyPress = () => {
  };

  useEffect(() => {
    calendar();
  }, [searchParams]);

  return (
    <section className="section">
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <div className="breadcrumbs mt-4">
              <div className="breadcrumbs-container">
                <BreadcrumbComponent />
              </div>
            </div>
            <div className="page-tab page-tab-two">
              <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item">
                  <a
                    className={
                      location.pathname === '/gallery/photoreport'
                      || location.pathname === '/gallery'
                        ? 'nav-link active'
                        : 'nav-link'
                    }
                    id="photos-tab"
                    data-toggle="tab"
                    href="/gallery/photoreport"
                    role="tab"
                    aria-controls="leaderNation"
                    aria-selected="true"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('photoreport');
                    }}
                  >
                    {dictionary.photos}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={
                      location.pathname === '/gallery/videoreport'
                        ? 'nav-link active'
                        : 'nav-link'
                    }
                    id="videos-tab"
                    data-toggle="tab"
                    href="/gallery/videoreport"
                    role="tab"
                    aria-controls="aboutCountry"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('videoreport');
                    }}
                  >
                    {dictionary.video}
                  </a>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent" style={{ paddingTop: '30px' }}>
                <Outlet />
              </div>
            </div>
          </div>
          <div className="col-lg-3 pl-lg-4 d-none d-lg-block mt-4">
            <div className="saidbar-content__title">
              <span>{dictionary.calendar}</span>
            </div>
            <div className="saidbar-calendar">
              <div className="calendar">
                <div
                  id="date8"
                  onClick={handleSelectSearchByDate}
                  onKeyDown={(e) => {
                    handleKeyPress(e, xCal.value);
                  }}
                  role="button"
                  tabIndex="0"
                  aria-label="calendar"
                />
              </div>

              <div className="saidbar-calendar__button">
                <button
                  type="button"
                  className="button"
                  onClick={() => {
                    searchParams.delete('date');
                    setSearchParams(searchParams);
                  }}
                >
                  {dictionary.restore}
                </button>
              </div>
            </div>
            <EventMore />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
